export enum CommonErrorName {
    invalid = "es inválid@.",
    required = "es obligatori@."
}
export enum CustomErrorName {
    rescheduledDateIsAfterLimitDate = "La nueva fecha de visita debe ser menor a la fecha de próxima revisión.",
    twoDaysWithLimitDate = "La nueva fecha de visita debe ser 2 días hábiles menor a la próxima revisión.",
    twoDaysWithCurrentDate = "La nueva fecha de visita debe ser 2 días hábiles mayor a la fecha actual.",
    rescheduledDateIsLikeScheduledDate = "La nueva fecha de visita no debe ser igual a la fecha de visita programada.",
    notInJobDays = "La nueva fecha de visita debe estar entre lunes y viernes.",
    differentEmailAddresses = "Los correos deben ser iguales",
    lotAndBlockOrStreetNumberIsNeeded = "Debe ingresar el número calle o ingrese campo manzana y lote(Dirección)",
    homePhoneOrCellPhoneIsNeeded = "Debe ingresar al menos un número de teléfono fijo o celular.",
    fatherOrMotherNameIsNeeded = "Debe ingresar el nombre del padre o madre",
    matDatepickerParse = "La fecha no es válida"
}

export enum FormControlName {
    name = "El nombre ",
    lastName = "Los apellidos ",
    homePhone = "El teléfono fijo ",
    cellPhone = "El celular ",
    documentType = "El tipo de documento ",
    documentNumber = "El número de documento ",
    code = "El código ",
    email = "El correo ",
    type = "El tipo de incidencia ",
    relationshipType = "El tipo de relación ",
    reason = "El motivo ",
    subReason = "El submotivo ",
    emailAddress = "El correo electrónico de notificación ",
    description = "La descripción ",
    number = "El número ",
    month = "El mes ",
    year = "El año ",
    firstNotificationAddress = "La dirección de ocurrencia ",
    departmentCode = "El departamento ",
    provinceCode = "La provincia  ",
    districtCode = "El distrito ",
    reference = "La referencia ",
    streetType = "El tipo de calle ",
    streetDescription = "El nombre de calle ",
    buildingType = "El tipo de edificio ",
    houseType = "El tipo de vivienda ",
    interiorType = "El tipo de interior ",
    birthDate = "La fecha de nacimiento ",
    birthPlace = "El lugar de nacimiento ",
    dniValidationDigit = "El dígito de verificación ",
    visitSchedule = "El horario de visita ",
    serviceType = "El tipo de servicio ",
    streetNumber="El numero de calle ",
    typeNoClient="El tipo de cliente",
    description_osi="La descripción ",
    isNotification='Es necesario marcar la notificación ',
    notificacionInput='Asigne un valor para la notificación ',
    isAcceptTerms='No ha acepto las politicas privacidad ',
    tipoBien='Debe seleccionar un tipo de bien',
    descripcionTipoBien="Debe ingresar una descripcion para el tipo de bien"
}
export enum FormControlGroupName {
    newClientAddress = "de la dirección de nuevo suministro",
    clientAddress = "de la dirección del cliente ",
    client = "del cliente ",
    bill = "del recibo ",
    representative = "del representante ",
    secondNotificationAddress = "de la dirección de notificación "
}